import { PermissionLevel } from "@/graphql";

// Changed from enum to const object with string values
export const ShareStatus = {
  [PermissionLevel.View]: "Can View",
  [PermissionLevel.Edit]: "Can Edit",
  [PermissionLevel.Share]: "Can Share",
  Remove: "Remove",
} as const;
